// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"3fd0db41","108":"b134ee8f","142":"7294447a","146":"a3f672d0","219":"94f1af9e","233":"1a8d6a66","274":"1219e72e","438":"b6bd0a54","460":"53d8a371","462":"3bbca5d6","486":"7f01face","672":"e0689ed6","680":"ced5c829","775":"b8ebe94c","826":"89f95bf4","960":"2c48a652"}[chunkId] + ".chunk.js";
};